<bl-page-card-container
  data-smartpresentation="container-pagina"
  id="lancamentos-rejeitados-outras-despesas"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="filters-row flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-5"></ag-views-toolbar>

      <div class="mr-2">
        <p-select
          size="small"
          [options]="motivoArquivoOptions"
          [(ngModel)]="selectedMotivoArquivo"
          dropdownIcon="pi pi-angle-down"
          (ngModelChange)="onFilterChange()"
          [showClear]="true"
          [style]="{ width: '240px' }"
          [panelStyle]="{ width: '360px', 'max-width': 'calc(100vw - 2rem)' }"
          placeholder="Selecione o motivo de arquivo"
          [filter]="true"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        ></p-select>
      </div>

      <div class="mr-2">
        <p-select
          size="small"
          [options]="motivoArquivoOptions"
          [(ngModel)]="selectedRejeicaoArquivo"
          dropdownIcon="pi pi-angle-down"
          (ngModelChange)="onFilterChange()"
          [showClear]="true"
          [style]="{ width: '245px' }"
          [panelStyle]="{ width: '360px', 'max-width': 'calc(100vw - 2rem)' }"
          placeholder="Selecione a rejeição de arquivo"
          [filter]="true"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        ></p-select>
      </div>

      <bl-competencia
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>

      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="ml-2 p-button p-button-md"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        [disabled]="!filterChanged"
        (click)="reloadData(true)"
      ></button>

      <bl-pesquisar-input
        class="ml-5 mr-5"
        (onSearch)="onSearch($event)"
        [disabled]="!rowData?.length"
      ></bl-pesquisar-input>

      <button
        class="p-button p-button-outlined p-button-icon-only mr-2"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!rowData?.length"
      >
        <i class="pi pi-file-excel"></i>
      </button>

      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
        >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-column flex-1 min-h-0">
    <div class="grid-wrapper">
      <ag-grid-angular
        #agGrid
        data-smartpresentation="ag-grid"
        class="ag-theme-balham w-full h-full"
        [style.height]="gridHeight$ | async"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
      >
      </ag-grid-angular>
    </div>
  </div>
</bl-page-card-container>
